import type { WriteTransaction } from 'replicache'
import {
  BlockRelationship,
  Branch,
  blockRelationshipBaseOps,
  branchBaseOps,
  getBRId,
  type RootBlock,
} from '@basehub/data/replicache/index'
import { branchMutators } from '../branch/mutators'
import type { RepositoryTemplate } from '@basehub/data/replicache/mutators/team-space/repository/types'
import { WithServerSecret } from '../../../tx/spec'
import {
  blockBaseOps,
  ensureBaseHubTransaction,
} from '@basehub/data/replicache/tx/iso'

async function initRepository(
  tx: WriteTransaction,
  {
    firstBlockId,
    firstBranchId,
    isoNow,
  }: WithServerSecret<{
    firstBlockId: string
    firstBranchId: string
    isoNow: string
    templateIdSeed: string | null
    templateName: RepositoryTemplate | null
  }>
) {
  ensureBaseHubTransaction(tx)
  // 4. create default branch + working root block on the new repo

  // just in case, make sure we don't have any existing branches
  const existingBranches = await branchMutators.listBranches(tx)

  if (existingBranches.length > 0) {
    console.warn(
      'attempted to initialize repo with existing branches or blocks'
    )
    return
  }

  const firstBranch: Branch = {
    id: firstBranchId,
    name: 'main',
    headCommitId: null,
    headCommit: null,
    workingRootBlockId: firstBlockId,
    isDefault: true,
    createdAt: isoNow,
    typesenseCollections: [],
    updatedAt: new Date().toISOString(),
  }

  const newBlock: RootBlock = {
    id: firstBlockId,
    branchId: firstBranch.id,
    title: 'root',
    type: 'root',
    value: {},
    constraints: {},
    createdAt: isoNow,
    typeOptions: {},
    isCommitted: false,
    hidden: false,
    sourceBlockId: null,
    searchConfig: { index: false },
  }

  const newRootBR: BlockRelationship = {
    branchId: firstBranch.id,
    validFrom: isoNow,
    id: getBRId(newBlock.id, newBlock.id),
    blockId: newBlock.id,
    sourceBlockId: newBlock.id,
    order: '',
    parentId: '',
    isCommitted: false,
    structural: true,
  }

  await Promise.all([
    branchBaseOps.put(tx, firstBranch),
    blockBaseOps.put(tx, newBlock, null),
    blockRelationshipBaseOps.put(tx, newRootBR),
  ])

  return { firstBlockId, firstBranch }
}

export const repoInitMutators = {
  initRepository,
}
